import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, TextField,
         Alert, useMediaQuery } from '@mui/material';
import { auth } from '../Common';

/** Cambio della propria password. Cambiandola, le altre sessioni vengono chiuse. */
export default function PasswordDialog({ open, onClose, notify }) {
  const fullScreen = useMediaQuery('(max-width:700px)');
  const [vecchia, setVecchia] = useState('');
  const [nuova, setNuova] = useState('');
  const [conferma, setConferma] = useState('');
  const [errore, setErrore] = useState(null);
  const [busy, setBusy] = useState(false);

  const chiudi = () => { setVecchia(''); setNuova(''); setConferma(''); setErrore(null); onClose(); };

  const salva = async (e) => {
    e.preventDefault();
    setErrore(null);
    if (nuova.length < 8) return setErrore('La nuova password deve avere almeno 8 caratteri.');
    if (nuova !== conferma) return setErrore('Le due password non coincidono.');
    setBusy(true);
    try {
      await auth.cambiaPassword(nuova, vecchia);
      notify('Password aggiornata ✓', 'success');
      chiudi();
    } catch (err) { setErrore(err.message); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onClose={chiudi} fullScreen={fullScreen} fullWidth maxWidth="xs">
      <DialogTitle>Cambia la tua password</DialogTitle>
      <form onSubmit={salva}>
        <DialogContent dividers>
          <Stack spacing={2}>
            {errore && <Alert severity="error">{errore}</Alert>}
            <TextField label="Password attuale" type="password" value={vecchia} fullWidth autoFocus
                       autoComplete="current-password" onChange={(e) => setVecchia(e.target.value)} />
            <TextField label="Nuova password" type="password" value={nuova} fullWidth
                       autoComplete="new-password" helperText="Almeno 8 caratteri"
                       onChange={(e) => setNuova(e.target.value)} />
            <TextField label="Ripeti la nuova password" type="password" value={conferma} fullWidth
                       autoComplete="new-password" onChange={(e) => setConferma(e.target.value)} />
            <Alert severity="info" sx={{ py: 0.5 }}>
              Cambiando la password, gli altri dispositivi dovranno rifare l'accesso.
            </Alert>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={chiudi}>Annulla</Button>
          <Button type="submit" variant="contained" disabled={busy}>Salva</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
